import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { sharedItemProviderFactory } from "@/Portal/Services/SharedItemProviderFactory";
import { BaseSendToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendToPortalPopupStrategy";
import { ISendToPortalWithPreviewPopupStrategy } from "@/Portal/Services/Strategies/ISendToPortalPopupStrategy";

class SendFromPortfolioStrategy extends BaseSendToPortalPopupStrategy implements ISendToPortalWithPreviewPopupStrategy {
    protected sharedItem: SharedItem;

    public readonly disclaimer = "";
    public readonly itemCheckOperation: number = LocalOperations.Portfolio.PortalSync_SendToPortal_MessageChecked;

    public get shouldShowFilePreview(): boolean {
        return sharedItemProviderFactory.get(this.sharedItem.SharedItemType).shouldShowFilePreviewInPortfolio();
    }

    public get canCheckItem(): boolean {
        switch (this.sharedItem.SharedItemType) {
            // prevent sharing of unsigned requests
            case PortalLinkedItemType.LabRequest:
            case PortalLinkedItemType.ConsultationRequest:
                return this.sharedItem.IncludeLinkedItem;

            default:
                return true;
        }
    }

    constructor(model: IPortalLinkedItemModel) {
        super(
            model.get("SharedItem").SharedItemType,
            LocalOperations.Portfolio.PortalSync_SendToPortal_RevokeClick,
            LocalOperations.Portfolio.PortalSync_SendToPortal_CancelClick
        );
        this.sharedItem = model.get("SharedItem");
    }

    public onSendToPortalClick(subject: string, newMessage: string, includeDocument: boolean, _portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean): void {
        const payload = {
            subject: subject,
            messageText: newMessage,
            includeDocument: includeDocument,
            priority: priority,
            canPatientReplyWithMessage: canPatientReplyWithMessage
        };

        // ensure a document or text cannot be added to a CommunicationHistory item
        if (this.linkedItemType === PortalLinkedItemType.CommunicationHistory) {
            payload.messageText = "";
            payload.includeDocument = false;
        }

        sessionStore.dispatch(
            LocalOperations.Portfolio.PortalSync_SendToPortal_SyncClick,
            payload
        );
    }
}

export { SendFromPortfolioStrategy };
